import { useRef, type KeyboardEvent, type MouseEvent } from 'react';

const interactive = 'a,button,input,textarea,select,[contenteditable="true"],[role="button"],[role~="dialog"]';
const hasSelection = () => {
  const selection = window.getSelection();
  return !!selection && selection.rangeCount > 0 && !selection.isCollapsed;
};

// Let the browser keep native text selection. Never prevent mouse defaults or clear a range.
export default function useSelectionSafeDoubleClick(enabled: boolean, onOpen: () => void) {
  const gesture = useRef({ x: 0, y: 0, dragged: false });
  return {
    tabIndex: enabled ? 0 : undefined,
    title: enabled ? 'ダブルクリックまたはEnterキーで編集（文字選択中は開きません）' : undefined,
    'aria-keyshortcuts': enabled ? 'Enter' : undefined,
    onMouseDown: (event: MouseEvent<HTMLElement>) => {
      if (event.detail < 2) gesture.current = { x: event.clientX, y: event.clientY, dragged: false };
    },
    onMouseMove: (event: MouseEvent<HTMLElement>) => {
      if ((event.buttons & 1) && Math.hypot(event.clientX - gesture.current.x, event.clientY - gesture.current.y) > 4) gesture.current.dragged = true;
    },
    onDoubleClick: (event: MouseEvent<HTMLElement>) => {
      if (enabled && event.button === 0 && !gesture.current.dragged && !hasSelection() && !(event.target as Element).closest(interactive)) onOpen();
    },
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
      if (enabled && event.key === 'Enter' && event.target === event.currentTarget && !event.repeat && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey && !hasSelection()) {
        event.preventDefault(); onOpen();
      }
    },
  };
}
